<template>
  <div class="">
    <v-alert
      v-if="countCC >= 1"
      class="elegant-alert"
      outlined
      prominent
      icon="mdi-bell-ring"
      type="error"
      border="left"
      elevation="3"
    >
      <v-row align="center" no-gutters>
        <v-col class="grow">
          <div class="alert-header">
            <v-icon color="primary" size="28" class="header-icon">mdi-school</v-icon>
            <h2 class="header-title primary--text">วิทยาลัย</h2>
          </div>
          <div class="alert-content">
            <h3 class="content-text">
              แจ้งยกเลิก ประเมินคะแนน
            </h3>
            <div class="count-badge">
              <v-chip
                color="error"
                text-color="white"
                small
                class="font-weight-bold"
              >
                {{ countCC }} ราย
              </v-chip>
            </div>
          </div>
        </v-col>
        <v-col class="shrink">
          <v-btn
            :to="actionRoute"
            color="primary"
            outlined
            large
            class="action-button"
            elevation="2"
          >
            <v-icon left>mdi-bell-ring</v-icon>
            ดำเนินการ
          </v-btn>
        </v-col>
      </v-row>
    </v-alert>
  </div>
</template>

<script>
export default {
  name: "HRvecAlertAssistantTeacher",

  data() {
    return {
      ApiKey: "HRvec2021",
      assistant_teacherscc: [],
      countCC: 0,
      actionRoute: "/admin/assistant_teacher"
    };
  },

  async mounted() {
    await this.loadAssistantTeacherData();
  },

  methods: {
    async loadAssistantTeacherData() {
      try {
        const result = await this.$http.post("assistant_teacher.php", {
          ApiKey: this.ApiKey,
          assistant_teacher_comment: "collegeCC"
        });
        
        this.assistant_teacherscc = result.data || [];
        this.countCC = this.assistant_teacherscc.length;
      } catch (error) {
        console.error("Error loading assistant teacher data:", error);
        this.countCC = 0;
      }
    }
  }
};
</script>

<style scoped>
.alert-container {
  padding: 16px;
  max-width: 800px;
  margin: 0 auto;
}

.elegant-alert {
  border-radius: 12px !important;
  border-left-width: 6px !important;
  background: linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%) !important;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08) !important;
  transition: all 0.3s ease;
}

.elegant-alert:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 30px rgba(0, 0, 0, 0.12) !important;
}

.alert-header {
  display: flex;
  align-items: center;
  margin-bottom: 12px;
}

.header-icon {
  margin-right: 12px;
}

.header-title {
  font-weight: 600;
  font-size: 1.5rem;
  margin: 0;
  letter-spacing: 0.5px;
}

.alert-content {
  margin-left: 40px;
}

.content-text {
  color: #424242;
  font-weight: 500;
  font-size: 1.1rem;
  line-height: 1.4;
  margin: 0 0 8px 0;
}

.count-badge {
  margin-top: 8px;
}

.action-button {
  border-radius: 8px !important;
  font-weight: 600;
  text-transform: none;
  letter-spacing: 0.5px;
  transition: all 0.3s ease;
}

.action-button:hover {
  transform: translateY(-1px);
  box-shadow: 0 4px 15px rgba(25, 118, 210, 0.3);
}

/* Responsive design */
@media (max-width: 768px) {
  .alert-container {
    padding: 8px;
  }
  
  .header-title {
    font-size: 1.3rem;
  }
  
  .content-text {
    font-size: 1rem;
  }
  
  .action-button {
    width: 100%;
    margin-top: 8px;
  }
  
  .alert-content {
    margin-left: 0;
    margin-top: 8px;
  }
}

/* Animation for alert appearance */
.elegant-alert {
  animation: slideIn 0.5s ease-out;
}

@keyframes slideIn {
  from {
    opacity: 0;
    transform: translateY(-20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
</style>